import { render, staticRenderFns } from "./TemplateViewer.vue?vue&type=template&id=68c85b26"
import script from "./TemplateViewer.vue?vue&type=script&lang=ts"
export * from "./TemplateViewer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports